export const menuList = [
  {
    icon: "saf-home-1",
    name: "dashboard",
    label: "Dashboard",
    navlink: "/dashboard",
  },
  {
    icon: "saf-3dcube",
    name: "exam groups",
    label: "Exam Groups",
    navlink: "/exam-groups",
  },
  {
    icon: "saf-stickynote",
    name: "papers",
    label: "Papers",
    navlink: "/papers",
  },
  {
    icon: "saf-category-2",
    name: "subjects",
    label: "Subjects",
    navlink: "/subjects",
  },
  {
    icon: "saf-stickynote",
    name: "feedback",
    label: "User Feedback",
    navlink: "/feedbacks",
  },
  {
    icon: "saf-pen-add",
    name: "manage-institutions",
    label: "manage institutions",
    navlink: "/manage-institutions",
  },
  {
    icon: "saf-driver",
    name: "transactions",
    label: "Transactions",
    navlink: "/transactions",
  },
  {
    icon: "saf-security-time",
    name: "quizathon",
    label: "quizathon",
    navlink: "/quizathon-list",
  },
];

